import { Link } from "react-router-dom";

export default function LinkButton({ colour, children, className, ...props }) {
  //Needs Button Config since tailwind doesn't allow dynamically changing variables
  const buttonConfig = {
    blue: {
      bgColour: "bg-[#46A4DD]",
      textColour: "text-white",
      hoverBgColour: "hover:bg-[#2894D7]", //Dark Blue
      hoverTextColour: "hover:text-white", //Dark Blue
    },
    orange: {
      bgColour: "bg-[#FE994F]",
      textColour: "text-white",
      hoverBgColour: "hover:bg-[#FE791b]", //Dark Orange
      hoverTextColour: "hover:text-white", //Dark Orange
    },
    white: {
      bgColour: "bg-white",
      textColour: "text-black",
      hoverBgColour: "hover:bg-grey-dark2",
      hoverTextColour: "hover:text-grey-dark2",
    },
  };

  return (
    <Link
      className={`${buttonConfig[colour].bgColour} ${buttonConfig[colour].hoverBgColour} ${buttonConfig[colour].textColour} rounded-xl border-0 p-3 w-25 text-center font-medium text-sm outline-none shadow-none my-2 ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}
